module.exports = __webpack_public_path__ + "img/text-effect-normal.5ed2ecfb.png";